import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

/**
 * Hook to fetch a single company's full details including instruments.
 */
const useTradingCompany = ({ companyId }: { companyId: number | undefined }) => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_company", companyId],
    () => scientApi.trading.getTradingCompany(companyId!),
    {
      retry: 1,
      enabled: companyId !== undefined,
    },
  )

  return {
    company: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingCompany
